<template>
  <v-row justify="center">
    <v-col cols="12" sm="8" md="4">
      <div v-if="$apollo.loading" :class="titleClass">
        Loading...
      </div>
      <notification-settings-card
        v-else
        :id="employee.id"
        :email="employee.email"
        :subscriptions="employee.subscriptions"
        @hide="$router.push({ name: 'profile' })"
        @refresh="$apollo.queries.employee.refresh()"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

import NotificationSettingsCard from "@/components/notification/NotificationSettingsCard.vue";

import EmployeeQuery from "@/graphql/Employee.gql";

export default {
  components: {
    NotificationSettingsCard,
  },
  data() {
    return {
      titleClass: "title text--secondary text-uppercase",
    };
  },
  computed: {
    ...mapState(["me"]),
  },
  apollo: {
    employee: {
      query: EmployeeQuery,
      variables() {
        return {
          id: this.me.id,
        };
      },

      skip() {
        return !(this.me && this.me.id);
      },
    },
  },
};
</script>
